
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M8 1a7 7 0 110 14A7 7 0 018 1zm-.5 3.25a.75.75 0 00-.75.75v3.5l.007.102a.75.75 0 00.743.648h3l.102-.007a.75.75 0 00.648-.743l-.007-.102a.75.75 0 00-.743-.648H8.25V5l-.007-.102A.75.75 0 007.5 4.25z"}})])
          )
        }
      }
    